/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BuildingExportType } from '../model/buildingExportType.model';
// @ts-ignore
import { ClientError } from '../model/clientError.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class BuildingExportService {

    protected basePath = 'http://localhost/assets-backend/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(@Inject(HttpClient) protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Inject(Configuration) @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Export buildings to file
     * Generates and downloads a file export of buildings based on the provided filter criteria. Supports two export types: basic building list or building list with detailed ownership information. The export includes cadastral data, location information, and optionally ownership details. Results can be filtered by department, cadastral area, building type, and owner information.
     * @param projectKey Project key for multi-tenant access control
     * @param buildingExportType Type of export: BUILDING_EXPORT_LIST for basic building list, BUILDING_EXPORT_LIST_WITH_OWNERS for list with ownership details
     * @param departmentId Filter by department ID - limits buildings to a specific organizational unit
     * @param offset Offset for pagination - number of records to skip
     * @param limit Limit for pagination - maximum number of records to return (0 &#x3D; no limit)
     * @param sortDir Sort direction: \&#39;asc\&#39; for ascending, \&#39;desc\&#39; for descending
     * @param sortedBy Field name to sort by (e.g., \&#39;name\&#39;, \&#39;customName\&#39;, \&#39;katuzeNazev\&#39;, \&#39;typbudNazev\&#39;)
     * @param name Filter by building name - partial match (case-insensitive)
     * @param ids Filter by specific building IDs - comma-separated list
     * @param area Filter by cadastral area codes (KATUZE_KOD) - comma-separated list
     * @param newVersionOnly Include only newest version of each building (true) or all versions (false)
     * @param typbudKodList Filter by building type codes (TYPBUD_KOD) - comma-separated list
     * @param zpvybuKodList Filter by building structure codes (ZPVYBU_KOD) - comma-separated list
     * @param concernedOwnership Filter by concerned ownership existence - true to include only buildings with concerned ownerships
     * @param ownershipLists Filter by ownership list IDs - comma-separated list
     * @param subjectIds Filter by subject (owner) IDs - comma-separated list
     * @param parcis Filter by parcel number (parcelní číslo) - partial match
     * @param parcelIds Filter by parcel IDs - comma-separated list of parcel identifiers
     * @param customName Filter by user-defined building name (Název budovy) - partial match (case-insensitive)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBuildingsExport(projectKey: string, buildingExportType: BuildingExportType, departmentId?: number, offset?: number, limit?: number, sortDir?: string, sortedBy?: string, name?: string, ids?: Array<number>, area?: Array<number>, newVersionOnly?: boolean, typbudKodList?: Array<number>, zpvybuKodList?: Array<number>, concernedOwnership?: boolean, ownershipLists?: Array<number>, subjectIds?: Array<number>, parcis?: string, parcelIds?: Array<number>, customName?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getBuildingsExport(projectKey: string, buildingExportType: BuildingExportType, departmentId?: number, offset?: number, limit?: number, sortDir?: string, sortedBy?: string, name?: string, ids?: Array<number>, area?: Array<number>, newVersionOnly?: boolean, typbudKodList?: Array<number>, zpvybuKodList?: Array<number>, concernedOwnership?: boolean, ownershipLists?: Array<number>, subjectIds?: Array<number>, parcis?: string, parcelIds?: Array<number>, customName?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getBuildingsExport(projectKey: string, buildingExportType: BuildingExportType, departmentId?: number, offset?: number, limit?: number, sortDir?: string, sortedBy?: string, name?: string, ids?: Array<number>, area?: Array<number>, newVersionOnly?: boolean, typbudKodList?: Array<number>, zpvybuKodList?: Array<number>, concernedOwnership?: boolean, ownershipLists?: Array<number>, subjectIds?: Array<number>, parcis?: string, parcelIds?: Array<number>, customName?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getBuildingsExport(projectKey: string, buildingExportType: BuildingExportType, departmentId?: number, offset?: number, limit?: number, sortDir?: string, sortedBy?: string, name?: string, ids?: Array<number>, area?: Array<number>, newVersionOnly?: boolean, typbudKodList?: Array<number>, zpvybuKodList?: Array<number>, concernedOwnership?: boolean, ownershipLists?: Array<number>, subjectIds?: Array<number>, parcis?: string, parcelIds?: Array<number>, customName?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (projectKey === null || projectKey === undefined) {
            throw new Error('Required parameter projectKey was null or undefined when calling getBuildingsExport.');
        }
        if (buildingExportType === null || buildingExportType === undefined) {
            throw new Error('Required parameter buildingExportType was null or undefined when calling getBuildingsExport.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (departmentId !== undefined && departmentId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>departmentId, 'departmentId');
        }
        if (offset !== undefined && offset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }
        if (sortDir !== undefined && sortDir !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDir, 'sortDir');
        }
        if (sortedBy !== undefined && sortedBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortedBy, 'sortedBy');
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (ids) {
            ids.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ids');
            })
        }
        if (area) {
            area.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'area');
            })
        }
        if (newVersionOnly !== undefined && newVersionOnly !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>newVersionOnly, 'newVersionOnly');
        }
        if (typbudKodList) {
            typbudKodList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'typbudKodList');
            })
        }
        if (zpvybuKodList) {
            zpvybuKodList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'zpvybuKodList');
            })
        }
        if (concernedOwnership !== undefined && concernedOwnership !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>concernedOwnership, 'concernedOwnership');
        }
        if (ownershipLists) {
            ownershipLists.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ownershipLists');
            })
        }
        if (subjectIds) {
            subjectIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'subjectIds');
            })
        }
        if (parcis !== undefined && parcis !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parcis, 'parcis');
        }
        if (parcelIds) {
            parcelIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'parcelIds');
            })
        }
        if (customName !== undefined && customName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>customName, 'customName');
        }
        if (buildingExportType !== undefined && buildingExportType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>buildingExportType, 'buildingExportType');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/${this.configuration.encodeParam({name: "projectKey", value: projectKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/buildings/export`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
